import OverallDevelopmentTemplate from './model';

export default OverallDevelopmentTemplate;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/OverallDevelopment/template/index.js